export default __webpack_public_path__ + "static/media/Payment.4b3dcfa1.png";